import DashboardChart from '@/containers/facility/Overview/Overview'

export const chartIdDashBordMappings = {
  cards: ["Dashboard_cards_0", "Dashboard_cards_1", "Dashboard_cards_2", "Dashboard_cards_3", ],
  charts: ["Dashboard_charts_0", "Dashboard_charts_1", "Dashboard_charts_2", "Dashboard_charts_3", "Dashboard_charts_4", "Dashboard_charts_5"]
}

export {
  DashboardChart
}